import { render } from "./BusinessDetails.vue?vue&type=template&id=4dd1f2d2"
import script from "./BusinessDetails.vue?vue&type=script&lang=js"
export * from "./BusinessDetails.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__